import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass($props.clsName ? `${$props.clsName} text-link` : 'text-link'),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click'))
  }, _toDisplayString($setup.text), 3);
}